import React, { useState } from 'react';
import { HeaderBookACall } from '../components/heylloyd/HeaderBookACall';
import { HeroSectionBookACall } from '../components/heylloyd/HeroSectionBookACall';
import { Calendar, X } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function HeyLloydBookACallPage() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  return <div className="min-h-screen bg-black font-sans text-white selection:bg-[#7FFF00]/20 selection:text-[#7FFF00]" data-id="element-2013">
      <HeaderBookACall data-id="element-2014" />
      <div id="hero" data-id="element-2015">
        <HeroSectionBookACall data-id="element-2016" />
      </div>

      {/* Book a Call CTA Section */}
      <section id="beneficios" className="py-12 md:py-20 lg:py-28 bg-gradient-to-b from-black to-gray-900" data-id="element-2017">
        <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-2018">
          <div className="mb-6 md:mb-10" data-id="element-2019">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4 md:mb-5 tracking-tight px-2" data-id="element-2020">
              Únete a la Revolución de la IA
              <span className="block text-[#7FFF00] mt-2" data-id="element-2021">
                Más Fácil que Nunca
              </span>
            </h2>
            <p className="text-base md:text-lg text-gray-100 max-w-2xl mx-auto leading-relaxed px-2" data-id="element-2022">
              Habla con nuestro equipo y descubre cómo implementar inteligencia
              artificial en tu negocio para crear y escalar productos digitales
              de forma profesional.
            </p>
          </div>

          <div id="proceso" className="bg-gray-900 rounded-2xl shadow-xl border border-gray-800 p-5 md:p-8 mb-6 max-w-2xl mx-auto" data-id="element-2023">
            <div className="space-y-5" data-id="element-2024">
              <div className="flex items-start gap-4 text-left" data-id="element-2025">
                <div className="flex-shrink-0 w-9 h-9 md:w-10 md:h-10 rounded-full bg-[#7FFF00]/20 border border-[#7FFF00]/50 flex items-center justify-center" data-id="element-2026">
                  <span className="text-[#7FFF00] font-bold text-sm md:text-base" data-id="element-2027">
                    1
                  </span>
                </div>
                <div data-id="element-2028">
                  <h3 className="font-bold text-white mb-1 text-base md:text-lg" data-id="element-2029">
                    Agenda tu llamada estratégica
                  </h3>
                  <p className="text-gray-200 text-sm md:text-base" data-id="element-2030">
                    Elige el horario que mejor se ajuste a tu agenda
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 text-left" data-id="element-2031">
                <div className="flex-shrink-0 w-9 h-9 md:w-10 md:h-10 rounded-full bg-[#7FFF00]/20 border border-[#7FFF00]/50 flex items-center justify-center" data-id="element-2032">
                  <span className="text-[#7FFF00] font-bold text-sm md:text-base" data-id="element-2033">
                    2
                  </span>
                </div>
                <div data-id="element-2034">
                  <h3 className="font-bold text-white mb-1 text-base md:text-lg" data-id="element-2035">
                    Consulta con expertos en IA
                  </h3>
                  <p className="text-gray-200 text-sm md:text-base" data-id="element-2036">
                    Nuestro equipo analizará tu caso y te mostrará cómo aplicar
                    IA a tu negocio específico
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 text-left" data-id="element-2037">
                <div className="flex-shrink-0 w-9 h-9 md:w-10 md:h-10 rounded-full bg-[#7FFF00]/20 border border-[#7FFF00]/50 flex items-center justify-center" data-id="element-2038">
                  <span className="text-[#7FFF00] font-bold text-sm md:text-base" data-id="element-2039">
                    3
                  </span>
                </div>
                <div data-id="element-2040">
                  <h3 className="font-bold text-white mb-1 text-base md:text-lg" data-id="element-2041">
                    Recibe tu plan de acción
                  </h3>
                  <p className="text-gray-200 text-sm md:text-base" data-id="element-2042">
                    Obtén una estrategia personalizada para implementar IA y
                    empezar a ver resultados
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-6 pt-6 border-t border-gray-800" data-id="element-2043">
              <a href="https://api.leadconnectorhq.com/widget/bookings/info-commerce-llamada-de-claridad-crea-tu-producto-digital-con-ia" target="_blank" rel="noopener noreferrer" data-id="element-2044">
                <Button variant="primary" size="lg" className="w-full text-base md:text-lg px-6 py-5 md:py-6 bg-[#7FFF00] hover:bg-[#6FEF00] text-black font-bold shadow-lg shadow-[#7FFF00]/20 hover:shadow-xl hover:shadow-[#7FFF00]/30" leftIcon={<Calendar className="w-5 h-5 md:w-6 md:h-6" data-id="element-2046" />} data-id="element-2045">
                  Agenda tu Llamada Estratégica Gratis
                </Button>
              </a>
              <p className="text-sm text-gray-200 mt-4" data-id="element-2047">
                Sin compromiso • Sesión de 30 minutos • Estrategia personalizada
              </p>
            </div>
          </div>

          <div id="resultados" className="grid grid-cols-3 gap-3 md:gap-6 max-w-3xl mx-auto" data-id="element-2048">
            <div className="bg-gray-900 rounded-xl p-4 md:p-6 border border-gray-800" data-id="element-2049">
              <div className="text-2xl md:text-3xl font-bold text-[#7FFF00] mb-1 md:mb-2" data-id="element-2050">
                100+
              </div>
              <p className="text-gray-200 text-xs md:text-sm" data-id="element-2051">
                Negocios transformados con IA
              </p>
            </div>
            <div className="bg-gray-900 rounded-xl p-4 md:p-6 border border-gray-800" data-id="element-2052">
              <div className="text-2xl md:text-3xl font-bold text-[#7FFF00] mb-1 md:mb-2" data-id="element-2053">
                95%
              </div>
              <p className="text-gray-200 text-xs md:text-sm" data-id="element-2054">
                Clientes satisfechos
              </p>
            </div>
            <div className="bg-gray-900 rounded-xl p-4 md:p-6 border border-gray-800" data-id="element-2055">
              <div className="text-2xl md:text-3xl font-bold text-[#7FFF00] mb-1 md:mb-2" data-id="element-2056">
                24/7
              </div>
              <p className="text-gray-200 text-xs md:text-sm" data-id="element-2057">
                Soporte continuo
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="w-full relative z-10 bg-black border-t border-gray-900" data-id="element-2058">
        <div className="max-w-5xl mx-auto px-4 md:px-6 py-4 md:py-6" data-id="element-2059">
          {/* Legal Disclaimer */}
          <div className="text-gray-300 text-[10px] leading-tight space-y-2 text-left" data-id="element-2060">
            <p data-id="element-2061">
              48 HRS AI CASH MACHINE y todo el equipo asociado no asume
              responsabilidad por los resultados, ingresos o éxito que puedas
              obtener, ni garantiza resultados específicos. El éxito depende en
              parte del tiempo que dediques y de tu implementación de las guías,
              estrategias y soporte proporcionados. Todo el contenido,
              entrenamientos, artículos y material educativo tiene fines
              formativos únicamente y no debe interpretarse como asesoría
              financiera, legal o de inversión.
            </p>

            <p data-id="element-2062">
              Aunque nuestros servicios, sistemas y productos están diseñados
              para ayudar a nuestros clientes a crear y lanzar productos
              digitales con IA, no ofrecemos garantías (explícitas o implícitas)
              sobre resultados, ventas o ingresos derivados del uso de las
              ideas, herramientas o estrategias presentadas.
            </p>

            <p data-id="element-2063">
              Los testimonios compartidos corresponden a experiencias reales de
              usuarios, pero no deben considerarse como resultados típicos, ya
              que cada persona obtiene resultados diferentes según su situación
              y las acciones que decida tomar.
            </p>

            <p data-id="element-2064">
              Cualquier cifra interna, ejemplo o caso de estudio mostrado tiene
              fines ilustrativos y no garantiza que tú obtendrás los mismos
              resultados.
            </p>

            <p data-id="element-2065">
              Este sitio no forma parte de Google, Google Inc., Facebook/Meta o
              Meta Inc.
            </p>

            <p data-id="element-2066">
              Además, este sitio no está avalado, patrocinado ni aprobado por
              Google ni Meta de ninguna manera.
            </p>
          </div>

          {/* Copyright */}
          <div className="text-center mt-4 pt-3 border-t border-gray-900" data-id="element-2067">
            <p className="text-gray-300 text-[10px] mb-1" data-id="element-2068">
              &copy; 2025 48 Hrs AI Cash Machine. Todos los derechos reservados.
            </p>
            <p className="text-gray-200 text-[10px] mb-1" data-id="element-2069">
              Soporte:{' '}
              <a href="mailto:support@truemarketer.com" className="text-[#7FFF00] hover:text-[#6FEF00] transition-colors" data-id="element-2070">
                support@truemarketer.com
              </a>
            </p>
            <div className="flex items-center justify-center gap-4 text-[10px]" data-id="element-2071">
              <button onClick={() => setShowTerms(true)} className="text-gray-200 hover:text-white transition-colors underline" data-id="element-2072">
                Términos
              </button>
              <span className="text-gray-400" data-id="element-2073">|</span>
              <button onClick={() => setShowPrivacy(true)} className="text-gray-200 hover:text-white transition-colors underline" data-id="element-2074">
                Privacidad
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Terms Modal */}
      {showTerms && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowTerms(false)} data-id="element-2075">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative border border-gray-800" onClick={e => e.stopPropagation()} data-id="element-2076">
            <button onClick={() => setShowTerms(false)} className="absolute top-4 right-4 text-gray-300 hover:text-white transition-colors" data-id="element-2077">
              <X className="w-6 h-6" data-id="element-2078" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-white" data-id="element-2079">
              Términos y Condiciones
            </h2>
            <div className="text-gray-200 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-2080">
              <p data-id="element-2081">
                Al registrarte y participar en el 48 Hrs AI Cash Machine
                Masterclass, aceptas los siguientes términos y condiciones:
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2082">
                1. Aceptación de Términos
              </h3>
              <p data-id="element-2083">
                Al acceder y utilizar este sitio web y registrarte para el
                evento, aceptas estar sujeto a estos términos y condiciones,
                todas las leyes y regulaciones aplicables.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2084">
                2. Uso del Servicio
              </h3>
              <p data-id="element-2085">
                El contenido proporcionado en el masterclass es solo para fines
                educativos e informativos. No garantizamos resultados
                específicos de ingresos o éxito comercial.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2086">
                3. Propiedad Intelectual
              </h3>
              <p data-id="element-2087">
                Todo el contenido, materiales, y recursos proporcionados son
                propiedad de 48 Hrs AI Cash Machine y están protegidos por
                derechos de autor. No está permitida la reproducción o
                distribución sin autorización expresa.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2088">
                4. Limitación de Responsabilidad
              </h3>
              <p data-id="element-2089">
                48 Hrs AI Cash Machine no será responsable de ningún daño
                directo, indirecto, incidental o consecuente que resulte del uso
                o la imposibilidad de usar nuestros servicios.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2090">
                5. Modificaciones
              </h3>
              <p data-id="element-2091">
                Nos reservamos el derecho de modificar estos términos en
                cualquier momento. El uso continuado del servicio después de
                cambios constituye la aceptación de los nuevos términos.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2092">Contacto</h3>
              <p data-id="element-2093">
                Para preguntas sobre estos términos, contacta:{' '}
                <a href="mailto:support@truemarketer.com" className="text-[#7FFF00] hover:text-[#6FEF00]" data-id="element-2094">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}

      {/* Privacy Modal */}
      {showPrivacy && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowPrivacy(false)} data-id="element-2095">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative border border-gray-800" onClick={e => e.stopPropagation()} data-id="element-2096">
            <button onClick={() => setShowPrivacy(false)} className="absolute top-4 right-4 text-gray-300 hover:text-white transition-colors" data-id="element-2097">
              <X className="w-6 h-6" data-id="element-2098" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-white" data-id="element-2099">
              Política de Privacidad
            </h2>
            <div className="text-gray-200 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-2100">
              <p data-id="element-2101">
                En 48 Hrs AI Cash Machine, nos comprometemos a proteger tu
                privacidad. Esta política describe cómo recopilamos, usamos y
                protegemos tu información personal.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2102">
                1. Información que Recopilamos
              </h3>
              <p data-id="element-2103">
                Recopilamos información que nos proporcionas directamente,
                incluyendo:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-2104">
                <li data-id="element-2105">Nombre y dirección de correo electrónico</li>
                <li data-id="element-2106">Información de registro del evento</li>
                <li data-id="element-2107">Comunicaciones que mantienes con nosotros</li>
              </ul>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2108">
                2. Uso de la Información
              </h3>
              <p data-id="element-2109">Utilizamos tu información para:</p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-2110">
                <li data-id="element-2111">
                  Proporcionar acceso al masterclass y materiales relacionados
                </li>
                <li data-id="element-2112">Enviar comunicaciones sobre el evento</li>
                <li data-id="element-2113">Mejorar nuestros servicios y contenido</li>
                <li data-id="element-2114">Cumplir con obligaciones legales</li>
              </ul>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2115">
                3. Compartir Información
              </h3>
              <p data-id="element-2116">
                No vendemos ni compartimos tu información personal con terceros
                para fines de marketing. Podemos compartir información con
                proveedores de servicios que nos ayudan a operar nuestro
                negocio.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2117">
                4. Seguridad de Datos
              </h3>
              <p data-id="element-2118">
                Implementamos medidas de seguridad técnicas y organizativas
                apropiadas para proteger tu información personal contra acceso
                no autorizado, alteración o destrucción.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2119">
                5. Tus Derechos
              </h3>
              <p data-id="element-2120">
                Tienes derecho a acceder, corregir o eliminar tu información
                personal. Para ejercer estos derechos, contáctanos en:{' '}
                <a href="mailto:support@truemarketer.com" className="text-[#7FFF00] hover:text-[#6FEF00]" data-id="element-2121">
                  support@truemarketer.com
                </a>
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2122">6. Cookies</h3>
              <p data-id="element-2123">
                Utilizamos cookies y tecnologías similares para mejorar tu
                experiencia en nuestro sitio web y analizar el uso del sitio.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2124">Contacto</h3>
              <p data-id="element-2125">
                Para preguntas sobre esta política de privacidad, contacta:{' '}
                <a href="mailto:support@truemarketer.com" className="text-[#7FFF00] hover:text-[#6FEF00]" data-id="element-2126">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}
    </div>;
}